module.exports = __webpack_public_path__ + "img/Triangle.96b87f73.png";